import { render, staticRenderFns } from "./QLVNCabinet.vue?vue&type=template&id=3edeee2e&scoped=true"
import script from "./QLVNCabinet.vue?vue&type=script&lang=js"
export * from "./QLVNCabinet.vue?vue&type=script&lang=js"
import style0 from "./QLVNCabinet.vue?vue&type=style&index=0&id=3edeee2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edeee2e",
  null
  
)

export default component.exports